'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const innerJoin = (arr1, arr2, selectKey1, selectKey2) => {
    const arr2Set = new Set(arr2.map(selectKey2));
    return arr1.filter((item) => arr2Set.has(selectKey1(item)));
};

exports.innerJoin = innerJoin;
//# sourceMappingURL=inner-join.js.map
